module.exports = __webpack_public_path__ + "assets/img/congratulations.e74b102b.gif";